import { ICarrierCompliance } from 'types'
import { ICarrierApplicationStates, Maybe } from 'types/FMSGraphqlTypes'
import {
  isCarrierComplianceApprovedForShipment,
  IShipment,
} from './isCarrierComplianceApprovedForShipment'

/**
 * @returns Whether or not a carrier is both activated and approved to cover the shipment. The carrier is approved
 * to cover the shipment if they meet the requirements or have an approved cover review.
 */
export const isCarrierAllowedToBookShipment = (
  carrierCompliance: Maybe<ICarrierCompliance>,
  shipment: Maybe<IShipment>
): boolean => {
  const { meetsRequirements, state } = carrierCompliance ?? {}
  const isCarrierApproved = isCarrierComplianceApprovedForShipment(shipment)

  return (
    state === ICarrierApplicationStates.activated &&
    (meetsRequirements === true || isCarrierApproved === true)
  )
}
